import { t as e } from "./chunk-lit-C22HS9_U.js";
import { c as t, o as n, t as r } from "./chunk-decorate-DzD3B-3W.js";
import { t as i } from "./chunk-context-request-event-Cfz92xK9.js";
import { n as a, t as o } from "./chunk-aria-live-region-context-CjEiC1Jo.js";
import { n as s, t as c } from "./chunk-cart-sections-Rozw-gsX.js";
import { t as l } from "./chunk-quickshop-DBSOZyE0.js";
import { t as u } from "./chunk-modal-context-Cb6E_bdk.js";
//#region node_modules/@lit/context/lib/value-notifier.js
var d = class {
	get value() {
		return this.o;
	}
	set value(e) {
		this.setValue(e);
	}
	setValue(e, t = !1) {
		let n = t || !Object.is(e, this.o);
		this.o = e, n && this.updateObservers();
	}
	constructor(e) {
		this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
			for (let [e, { disposer: t }] of this.subscriptions) e(this.o, t);
		}, e !== void 0 && (this.value = e);
	}
	addCallback(e, t, n) {
		if (!n) return void e(this.value);
		this.subscriptions.has(e) || this.subscriptions.set(e, {
			disposer: () => {
				this.subscriptions.delete(e);
			},
			consumerHost: t
		});
		let { disposer: r } = this.subscriptions.get(e);
		e(this.value, r);
	}
	clearCallbacks() {
		this.subscriptions.clear();
	}
}, f = class extends Event {
	constructor(e, t) {
		super("context-provider", {
			bubbles: !0,
			composed: !0
		}), this.context = e, this.contextTarget = t;
	}
}, p = class extends d {
	constructor(e, t, n) {
		super(t.context === void 0 ? n : t.initialValue), this.onContextRequest = (e) => {
			if (e.context !== this.context) return;
			let t = e.contextTarget ?? e.composedPath()[0];
			t !== this.host && (e.stopPropagation(), this.addCallback(e.callback, t, e.subscribe));
		}, this.onProviderRequest = (e) => {
			if (e.context !== this.context || (e.contextTarget ?? e.composedPath()[0]) === this.host) return;
			let t = /* @__PURE__ */ new Set();
			for (let [e, { consumerHost: n }] of this.subscriptions) t.has(e) || (t.add(e), n.dispatchEvent(new i(this.context, n, e, !0)));
			e.stopPropagation();
		}, this.host = e, t.context === void 0 ? this.context = t : this.context = t.context, this.attachListeners(), this.host.addController?.(this);
	}
	attachListeners() {
		this.host.addEventListener("context-request", this.onContextRequest), this.host.addEventListener("context-provider", this.onProviderRequest);
	}
	hostConnected() {
		this.host.dispatchEvent(new f(this.context, this.host));
	}
};
//#endregion
//#region node_modules/@lit/context/lib/decorators/provide.js
function m({ context: e }) {
	return (t, n) => {
		let r = /* @__PURE__ */ new WeakMap();
		if (typeof n == "object") return {
			get() {
				return t.get.call(this);
			},
			set(e) {
				return r.get(this).setValue(e), t.set.call(this, e);
			},
			init(t) {
				return r.set(this, new p(this, {
					context: e,
					initialValue: t
				})), t;
			}
		};
		{
			t.constructor.addInitializer(((t) => {
				r.set(t, new p(t, { context: e }));
			}));
			let i = Object.getOwnPropertyDescriptor(t, n), a;
			if (i === void 0) {
				let e = /* @__PURE__ */ new WeakMap();
				a = {
					get() {
						return e.get(this);
					},
					set(t) {
						r.get(this).setValue(t), e.set(this, t);
					},
					configurable: !0,
					enumerable: !0
				};
			} else {
				let e = i.set;
				a = {
					...i,
					set(t) {
						r.get(this).setValue(t), e?.call(this, t);
					}
				};
			}
			Object.defineProperty(t, n, a);
			return;
		}
	};
}
//#endregion
//#region src/entry/core/app-provider.ts
var h = {
	OPEN: "modal-dialog::open",
	CLOSE: "modal-dialog::close",
	CLOSE_ALL: "modal-dialog::close-all"
}, g = {
	UPDATED: "cart:updated",
	UPDATED_SECTIONS: "cart:updated-sections"
}, _ = {
	OPEN: "quickshop::open",
	CLOSE: "quickshop::close"
}, v = "modals", y = class extends e {
	constructor(...e) {
		super(...e), this.cart = window.__CART__, this.cartSections = {}, this.modals = [], this.quickShop = null;
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		this.addEventListener(g.UPDATED, this._handleCartUpdate.bind(this)), this.addEventListener(g.UPDATED_SECTIONS, this._handleCartSectionsUpdate.bind(this)), this.addEventListener(o.SET, this._handleAriaLiveRegionSet.bind(this)), this.addEventListener(o.CLEAR, this._handleAriaLiveRegionClear.bind(this)), this.addEventListener("click", this._handleDialogSchemaClick.bind(this)), Object.values(h).forEach((e) => {
			this.addEventListener(e, this._handleDialogEvent.bind(this));
		}), Object.values(_).forEach((e) => {
			this.addEventListener(e, this._handleQuickShopEvent.bind(this));
		}), this._handleRestoreModals();
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.removeEventListener(g.UPDATED, this._handleCartUpdate.bind(this)), this.removeEventListener(g.UPDATED_SECTIONS, this._handleCartSectionsUpdate.bind(this)), this.removeEventListener(o.SET, this._handleAriaLiveRegionSet.bind(this)), this.removeEventListener(o.CLEAR, this._handleAriaLiveRegionClear.bind(this)), this.removeEventListener("click", this._handleDialogSchemaClick.bind(this)), Object.values(h).forEach((e) => {
			this.removeEventListener(e, this._handleDialogEvent.bind(this));
		}), Object.values(_).forEach((e) => {
			this.removeEventListener(e, this._handleQuickShopEvent.bind(this));
		});
	}
	_handleCartUpdate(e) {
		e.detail && (this.cart = e.detail);
	}
	_handleCartSectionsUpdate(e) {
		e.detail && (this.cartSections = e.detail || {});
	}
	_handleDialogSchemaClick(e) {
		let t = e.composedPath(), n = t.length > 0 ? t[0] : e.target;
		if (n.tagName === "A") {
			let t = n.getAttribute("href");
			if (t && (t.startsWith("modal-dialog://") || t.startsWith("#modal-dialog://"))) {
				e.preventDefault();
				let n = t.replace("modal-dialog://", "").replace("#", "");
				n && this._handleDialogEvent(new CustomEvent(h.OPEN, { detail: n }));
			}
		}
	}
	_handleDialogEvent(e) {
		let t = [...this.modals];
		switch (e.type) {
			case h.OPEN:
				e.detail && (t = [...t, e.detail]);
				break;
			case h.CLOSE:
				e.detail && (t = t.filter((t) => t !== e.detail)), this.quickShop = null;
				break;
			case h.CLOSE_ALL:
				t = [], this.quickShop = null;
				break;
		}
		t = [...new Set(t)], this.modals = t, this._applyModalsState(), this._updateQueryParams();
	}
	async _applyModalsState() {
		await customElements.whenDefined("modal-dialog");
		let e = this.modals, t = Array.from(this.querySelectorAll("modal-dialog"));
		for (let n of t) e.includes(n.id) ? n.show() : n.hide();
	}
	_handleRestoreModals() {
		let e = new URLSearchParams(window.location.search).get(v);
		e && (this.modals = e.split(",").map((e) => e.trim()).filter(Boolean), this._applyModalsState());
	}
	_updateQueryParams() {
		let e = new URLSearchParams(window.location.search), t = this.modals, n = this.modals.join(",");
		t.length > 0 ? e.set(v, n) : e.delete(v);
		let r = `${window.location.pathname}?${e.toString()}`;
		window.history.replaceState({}, "", r);
	}
	_handleAriaLiveRegionSet(e) {
		e.detail && (this.ariaLiveRegion = e.detail);
	}
	_handleAriaLiveRegionClear() {
		this.ariaLiveRegion = { message: "" };
	}
	_handleQuickShopEvent(e) {
		let t = e.type, n = e.detail;
		t === _.OPEN ? this.quickShop = n : this.quickShop = null;
	}
};
r([m({ context: s }), n()], y.prototype, "cart", void 0), r([m({ context: c }), n()], y.prototype, "cartSections", void 0), r([m({ context: u }), n()], y.prototype, "modals", void 0), r([m({ context: a }), n()], y.prototype, "ariaLiveRegion", void 0), r([m({ context: l }), n()], y.prototype, "quickShop", void 0), y = r([t("app-provider")], y);
//#endregion
export { y as AppProvider };
